"use client";

import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import FreeCoursesSectionInCourse from "@/components/common/FreeCoursesSectionInCourse";
import "./free-courses.css";

// Register GSAP plugins
if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}

const FreeCoursesSection = () => {
  const sectionRef = useRef(null);
  const headerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate section header
      gsap.fromTo(
        headerRef.current.children,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: headerRef.current,
            start: "top 80%",
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="free-courses-section">
      {/* Background elements */}
      <div className="free-courses-bg">
        <div className="bg-pattern"></div>
        <div className="bg-gradient"></div>
      </div>
      
      <div className="container mx-auto px-4">
        <div ref={headerRef} className="section-header">
          <h2 className="section-title">FREE RESOURCES</h2>
          <p className="section-subtitle">
            Explore our free courses to enhance your skills before enrollment. 
            These resources will help you get started on your journey to your dream job.
          </p>
        </div>
        
        <FreeCoursesSectionInCourse />
      </div>
    </section>
  );
};

export default FreeCoursesSection;
